<template>
  <div class="order-delete-tip">
    <el-dialog title="删单提示" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <p>提交舱单删除报文前，请确认</p>
        <p style="color:#ED6A0C">1.若需要删除拼箱舱单，请同时删除该箱号下所有舱单，否则会导致删除失败，且费用不退回！</p>
        <p style="color:#ED6A0C">2.本次删除的舱单均未报关：</p>
        <p style="padding-left:24px">若已报关，但在自由变更时间内，请删除报关单后，线上删除本舱单；</p>
        <p style="padding-left:24px">若已报关，且已超过自由变更时间，请联系船代进行柜台删单；</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="getDeleteOrderFee">继续</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "OrderDeleteTip",
  props: {
    visible: Boolean
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: '', label: '主提单号'},
          { prop: '', label: '分提单号'},
          { prop: '', label: '消费金额'}
        ]
      },
    }
  },
  created() {
    
  },
  methods: {
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    },
    getDeleteOrderFee(){
      this.$emit("closeDialog")
      this.$emit('getDeleteOrderFee')
    }
  }
}
</script>

<style scoped lang="less">
.order-delete-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 80px;
    padding: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
}
</style>